import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-transmission" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Salud porcentaje"),
  /*#__PURE__*/_createElementVNode("th", null, "Salud deducción"),
  /*#__PURE__*/_createElementVNode("th", null, "Pensión porcentaje"),
  /*#__PURE__*/_createElementVNode("th", null, "Pensión deducción")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "percent",
            prefix: "%",
            mode: "decimal",
            maxFractionDigits: 2,
            class: _normalizeClass(["pv-input-size input-number", { 'p-invalid': $setup.v$.HealthPercentage.$error }]),
            onBlur: _cache[0] || (_cache[0] = ($event: any) => ($setup.v$.HealthPercentage.$touch())),
            modelValue: $setup.saludPension.HealthPercentage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.saludPension.HealthPercentage) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.HealthDeduction.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.HealthDeduction.$touch())),
            modelValue: $setup.saludPension.HealthDeduction,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.saludPension.HealthDeduction) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "percent",
            prefix: "%",
            mode: "decimal",
            maxFractionDigits: 2,
            class: _normalizeClass(["pv-input-size input-number", { 'p-invalid': $setup.v$.PensionPercentage.$error }]),
            onBlur: _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.PensionPercentage.$touch())),
            modelValue: $setup.saludPension.PensionPercentage,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.saludPension.PensionPercentage) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PensionDeduction.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[6] || (_cache[6] = ($event: any) => ($setup.v$.PensionDeduction.$touch())),
            modelValue: $setup.saludPension.PensionDeduction,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.saludPension.PensionDeduction) = $event))
          }, null, 8, ["modelValue", "class"])
        ])
      ]),
      _createElementVNode("tr", _hoisted_3, [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.HealthPercentage.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.HealthPercentage.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.HealthDeduction.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.HealthDeduction.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PensionPercentage.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.PensionPercentage.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PensionDeduction.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.PensionDeduction.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}